import { render, staticRenderFns } from "./protocol.vue?vue&type=template&id=37afeda4&scoped=true&name=protocol"
var script = {}
import style0 from "./protocol.vue?vue&type=style&index=0&id=37afeda4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37afeda4",
  null
  
)

export default component.exports